import { Box, Paper, useMediaQuery, useTheme } from '@mui/material';
import Header from '../../components/Header/Header';
import RoutesManager from '../../components/layout/routes/RoutesManager';

const sectionManagerStyles = {
    margin: '32px 48px',
    overflow: 'auto',
    height: 'calc(100% - 124px)',
    '& .MuiPaper-root': {
        height: '100%',
        width: '100%',
        typography: 'body1',
        '& .MuiTabs-indicator': {
            backgroundColor: 'var(--primary)'
        }
    },
    '& .tabs-container': {
        height: '-webkit-fill-available', // 'inherit'
        padding: '24px 40px 24px 40px',
        overflow: 'auto'
    },
    '& .admin-section-wrapper': {
        height: 'calc(100% - 187px)',
        minHeight: '300px'
    },
    '& .section-wrapper': { height: 'auto' },
    '& .MuiTabs-root': {
        '& .MuiTab-root': {
            textTransform: 'capitalize',
            fontSize: '16px',
            minHeight: '48px'
        },
        '& .MuiTabs-flexContainer': {
            overflow: 'auto'
        }
    }
};

function Home() {
    const theme = useTheme();
    const isTablet = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <div className="bg-container">
            <Header />
            {!isTablet && (
                <Box sx={{ ...sectionManagerStyles }}>
                    <Paper>
                        <Box className="tabs-container">
                            <RoutesManager />
                        </Box>
                    </Paper>
                </Box>
            )}
        </div>
    );
}

export default Home;
